module.exports = __webpack_public_path__ + "static/media/edit_audio_detail.65bb8b6c.svg";